import { FinanceValueObjectsTaxTypeEnum } from 'generated/resources/graphql'

import SelectField from 'modules/core/components/SelectField'
import i18n from 'modules/core/lib/i18n'

interface TaxTypeTypeSelectorProps {
  selectedValue?: FinanceValueObjectsTaxTypeEnum
  error?: string
  readonly?: boolean
  onChangeType: (type: FinanceValueObjectsTaxTypeEnum) => void
}

export const TaxTypeTypeSelector = ({
  selectedValue,
  error,
  onChangeType,
  readonly = false,
}: TaxTypeTypeSelectorProps) => {
  const options = [
    {
      value: 'vat',
      label: i18n.t('finance.modals.new_tax_type.fields.type_selector.options.vat'),
    },
    {
      value: 'personal_income',
      label: i18n.t('finance.modals.new_tax_type.fields.type_selector.options.personal_income'),
    },
  ]

  return (
    <SelectField
      label={i18n.t('finance.modals.new_tax_type.fields.type_selector.label')}
      options={options}
      // eslint-disable-next-line no-type-assertion/no-type-assertion
      onChange={(value) => onChangeType(value as FinanceValueObjectsTaxTypeEnum)}
      defaultOption={{
        label: i18n.t('finance.modals.new_tax_type.fields.type_selector.options.default'),
        value: false,
      }}
      value={selectedValue}
      error={error}
      mandatory
      readonly={readonly}
    />
  )
}
